import { Editor, type EditorEvent, type Events, type Ui } from 'tinymce';
import { NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import * as FlatModels from '@medsurf/flat-models';
import { MediaControlService } from '@medsurf/flat-services';
import * as BasePlugin from '../base/media.base.plugin.editor';

export const register = (
  editor: Editor,
  zone: NgZone,
  translate: TranslateService,
  dialogService: DialogService,
  mediaControlService: MediaControlService
) => {

  const nodeChangedCallback = (
		buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi,
		event: EditorEvent<Events.NodeChangeEvent>
	) => {
    const element = (<HTMLElement>event.element);
    const isAudio = element?.tagName?.toLowerCase() === 'audio' || element?.dataset['mceObject'] === 'audio';

    buttonApi.setEnabled(isAudio || editor.selection.getContent() === '');
    buttonApi.setActive(isAudio);
  }

  const onSetup = (buttonApi: Ui.Toolbar.ToolbarToggleButtonInstanceApi) => {
    editor.on('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
    return () => {
      editor.off('NodeChange', (event) => nodeChangedCallback(buttonApi, event));
    };
  };

  const onAction = () => {
    const allowedTypes: FlatModels.MediaEntityModels.MediaType[] = [FlatModels.MediaEntityModels.MediaType.enum.MediaAudio];

    const node = <HTMLElement>editor.selection.getNode();
    const isAudio = node?.tagName?.toLowerCase() === 'audio';
    const id = node.dataset['id'];

    const selected: FlatModels.ModalAuthorModels.SelectedMediaDialogItem | undefined =
      isAudio && id ? { id, type: FlatModels.MediaEntityModels.MediaType.enum.MediaAudio } : undefined;

    try {
      zone.run(async () => {
        
        editor.editorManager.focusedEditor = null;
        const media = await BasePlugin.openMediaDialog(
          translate.instant("global.audio_edit"),
          dialogService,
          allowedTypes,
          selected
        )
        editor.editorManager.focusedEditor = editor;

        if (!media) return;
        const url = mediaControlService.getEditorUrl(media);
        
        if (isAudio) {
          editor.dom.setAttribs(node, {
            src: url,
            'data-id': media.id,
            'data-mce-src': url
          });
          editor.dispatch('change');
        } else {
          const newAudio: HTMLAudioElement = document.createElement('audio');
          newAudio.setAttribute('src', url);
          newAudio.setAttribute('data-id', media.id);
          newAudio.setAttribute('controls', '');
          newAudio.setAttribute('controlsList', 'nodownload');
          editor.insertContent(newAudio.outerHTML);
        }
      });
    } catch (err) {
      return;
    }
  }

  editor.ui.registry.addToggleButton('mediaaudio', {
    icon: 'audio',
    tooltip: 'Insert/edit audio',
    onAction,
    onSetup
  });
}